import type { ChatMode } from './types';
import { useChatModeStore } from './useChatModeStore';

export const useChatModeState: (key: string) => ChatMode = (key) => {
	const state = useChatModeStore(key)[0];
	return state;
};
